import fetch from '../../../../utils/fetch'
import * as types from './mutation_types'

export const getItems = ({ commit }, { sortBy, page }) => {
  commit(types.TOGGLE_LOADING)
  commit(types.SET_ERROR, '')

  let pageUrl = 'games?expand[]=game.gameFile&expand[]=game.version&expand[]=game.brand&'

  if (sortBy) {
    pageUrl = pageUrl + sortBy
  } else {
    pageUrl = pageUrl + 'order[name]=asc'
  }

  if (page) {
    pageUrl = page
  }

  return fetch(pageUrl)
    .then(response => response.json())
    .then((data) => {
      commit(types.SET_ITEMS, data['hydra:member'])
      commit(types.SET_VIEW, data['hydra:view'])
    })
    .catch((e) => {
      commit(types.SET_ERROR, e.message)
    })
    .finally(() => {
      commit(types.TOGGLE_LOADING)
    })
}

export const setActive = ({ commit }, { id, active }) => {
  commit(types.SET_ITEM_ACTIVE_LOADING)
  commit(types.SET_ITEM_ACTIVE_ERROR, '')
  commit(types.SET_ITEM_ACTIVE, { active, toggle: false, id })

  return fetch(id, { method: 'PUT', body: JSON.stringify({ active }) })
    .then(response => response.json())
    .then((data) => {
      commit(types.SET_ITEM, data)
    })
    .catch((e) => {
      commit(types.SET_ITEM_ACTIVE, { active, toggle: true, id })
      commit(types.SET_ITEM_ACTIVE_ERROR, e.message)
    })
    .finally(() => {
      commit(types.SET_ITEM_ACTIVE_LOADING)
    })
}

export const setActiveCheckbox = ({ commit }, { id, active, toggle }) => {
  commit(types.SET_ITEM_ACTIVE, { active, toggle, id })
}

export const getAllItems = ({ commit }, { page, clearPrev }) => {
  commit(types.SET_LOADING, true)
  commit(types.SET_ERROR, '')

  let pageUrl = 'games?expand[]=game.gameFile&expand[]=game.version&expand[]=game.brand&order[name]=asc'

  if (page) {
    pageUrl = page
  }

  if (clearPrev) {
    commit(types.SET_ALL_ITEMS, { items: [], clearPrev: true })
  }

  return fetch(pageUrl)
    .then(response => response.json())
    .then((data) => {
      commit(types.SET_ALL_ITEMS, { items: data['hydra:member'] })
      if (data['hydra:view']['hydra:next']) {
        return getAllItems({ commit }, { page: data['hydra:view']['hydra:next'] })
      } else {
        commit(types.SET_LOADING, false)
      }
    })
    .catch((e) => {
      commit(types.SET_ERROR, e.message)
      commit(types.SET_LOADING, false)
    })
}

export const setAllItems = ({ commit }, { items }) => {
  commit(types.SET_ALL_ITEMS, { items, clearPrev: true })
}
